import React from 'react';
import KakaoAdBanner from './KakaoAdBanner';

function Home({ onNavigate, showInlineMobileAd }) {
  return (
    <div>
      {/* Hero */}
      <div className="lb-page-hero">
        <div className="lb-container">
          <p className="lb-eyebrow-hand">라떼 한 잔 값으로 시작하는 노후준비 ☕</p>
          <h1 className="lb-title-lg">두 가지 방식으로<br />노후 자금을 계획하세요</h1>
          <p className="lb-body">
            월 저축액에서 생활비를 계산하거나, 원하는 생활비에서 필요한 저축액을 역산합니다.
            복리 계산과 현금흐름 시뮬레이션으로 실질적인 노후 준비를 도와드립니다.
          </p>
          <a
            className="lb-btn lb-btn-outline"
            href="https://comm.beaver-pension.com/?source=calculator&utm_source=calculator&utm_medium=cta"
            style={{ marginTop: '18px', display: 'inline-flex' }}
          >
            연금 질문하기
          </a>
        </div>
      </div>

      {/* Calculator cards */}
      <section className="lb-section">
        <div className="lb-container">
          <div className="lb-grid-2">

            {/* 일반 계산기 */}
            <article
              className="lb-card lb-card-padded calc-card"
              onClick={() => onNavigate('forward')}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === 'Enter' && onNavigate('forward')}
            >
              <div className="lb-card-icon">🧮</div>
              <p className="lb-eyebrow" style={{ marginTop: '4px' }}>Forward Calculator</p>
              <h2 className="lb-title-md" style={{ marginTop: '8px' }}>일반 계산기</h2>
              <p className="lb-card-desc">
                <strong>월 저축액 → 노후 생활비</strong><br />
                매월 얼마씩 저축하면 노후에 얼마나 쓸 수 있는지 계산합니다.
              </p>

              <div className="lb-card" style={{ marginTop: '16px', padding: '16px' }}>
                <p style={{ fontSize: '13px', fontWeight: '800', color: 'var(--color-brown-700)', marginBottom: '8px' }}>📋 입력 항목</p>
                <ul style={{ margin: 0, paddingLeft: '18px', fontSize: '13px', color: 'var(--color-text-sub)', lineHeight: '1.8' }}>
                  <li>현재 나이 / 은퇴 나이</li>
                  <li>월 납입액</li>
                  <li>연 복리 수익률</li>
                  <li>은퇴 후 수익률 / 기대수명</li>
                </ul>
              </div>

              <div className="lb-card" style={{ marginTop: '10px', padding: '16px', background: 'rgba(200, 135, 74, 0.08)' }}>
                <p style={{ fontSize: '13px', fontWeight: '800', color: 'var(--color-brown-700)', marginBottom: '8px' }}>📈 계산 결과</p>
                <ul style={{ margin: 0, paddingLeft: '18px', fontSize: '13px', color: 'var(--color-text-sub)', lineHeight: '1.8' }}>
                  <li>최종 적립액</li>
                  <li><strong>원금 보존/소진 월 수령액</strong></li>
                  <li>연도별 적립 시뮬레이션</li>
                </ul>
              </div>

              <button
                className="lb-btn lb-btn-primary"
                style={{ width: '100%', marginTop: '20px' }}
                onClick={(e) => { e.stopPropagation(); onNavigate('forward'); }}
              >
                일반 계산기 사용하기
              </button>
            </article>

            {showInlineMobileAd && (
              <KakaoAdBanner className="calc-home-mobile-ad" placement="mobile" />
            )}

            {/* 역산 계산기 */}
            <article
              className="lb-card lb-card-padded calc-card"
              onClick={() => onNavigate('reverse')}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === 'Enter' && onNavigate('reverse')}
            >
              <div className="lb-card-icon">🎯</div>
              <p className="lb-eyebrow" style={{ marginTop: '4px' }}>Reverse Calculator</p>
              <h2 className="lb-title-md" style={{ marginTop: '8px' }}>역산 계산기</h2>
              <p className="lb-card-desc">
                <strong>원하는 생활비 → 필요 저축액</strong><br />
                노후에 원하는 생활비를 위해 지금부터 얼마씩 저축해야 하는지 계산합니다.
              </p>

              <div className="lb-card" style={{ marginTop: '16px', padding: '16px' }}>
                <p style={{ fontSize: '13px', fontWeight: '800', color: 'var(--color-brown-700)', marginBottom: '8px' }}>📋 입력 항목</p>
                <ul style={{ margin: 0, paddingLeft: '18px', fontSize: '13px', color: 'var(--color-text-sub)', lineHeight: '1.8' }}>
                  <li>현재 나이 / 은퇴 나이</li>
                  <li><strong>원하는 월 생활비</strong></li>
                  <li>연 복리 수익률</li>
                  <li>은퇴 후 수익률 / 기대수명</li>
                </ul>
              </div>

              <div className="lb-card" style={{ marginTop: '10px', padding: '16px', background: 'rgba(200, 135, 74, 0.08)' }}>
                <p style={{ fontSize: '13px', fontWeight: '800', color: 'var(--color-brown-700)', marginBottom: '8px' }}>📈 계산 결과</p>
                <ul style={{ margin: 0, paddingLeft: '18px', fontSize: '13px', color: 'var(--color-text-sub)', lineHeight: '1.8' }}>
                  <li>원금 보존/소진 필요 적립액</li>
                  <li><strong>원금 보존/소진 월 저축액</strong></li>
                  <li>연도별 저축 시뮬레이션</li>
                </ul>
              </div>

              <button
                className="lb-btn lb-btn-outline"
                style={{ width: '100%', marginTop: '20px' }}
                onClick={(e) => { e.stopPropagation(); onNavigate('reverse'); }}
              >
                역산 계산기 사용하기
              </button>
            </article>

          </div>
        </div>
      </section>

      {/* Comparison table */}
      <section className="lb-section-sm" style={{ background: 'rgba(250, 242, 232, 0.4)' }}>
        <div className="lb-container">
          <div className="lb-section-head">
            <p className="lb-eyebrow">Comparison</p>
            <h2 className="lb-title-md">두 계산기 비교</h2>
          </div>
          <table className="lb-table">
            <thead>
              <tr>
                <th>구분</th>
                <th>🧮 일반 계산기</th>
                <th>🎯 역산 계산기</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ fontWeight: '700' }}>계산 방향</td>
                <td>저축액 → 생활비</td>
                <td>생활비 → 저축액</td>
              </tr>
              <tr>
                <td style={{ fontWeight: '700' }}>핵심 질문</td>
                <td>
                  <small>"월 100만원 저축하면<br />노후에 얼마나 쓸 수 있을까?"</small>
                </td>
                <td>
                  <small>"노후에 월 300만원 쓰려면<br />지금부터 얼마씩 저축해야 할까?"</small>
                </td>
              </tr>
              <tr>
                <td style={{ fontWeight: '700' }}>사용 상황</td>
                <td><small>현재 저축 여력이 정해진 경우</small></td>
                <td><small>목표 생활 수준이 정해진 경우</small></td>
              </tr>
              <tr>
                <td style={{ fontWeight: '700' }}>주요 결과</td>
                <td>
                  <span className="lb-badge">월 수령액 비교</span>
                </td>
                <td>
                  <span className="lb-badge">필요 저축액 비교</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      {/* Disclaimer */}
      <section className="lb-section-sm">
        <div className="lb-container">
          <div className="lb-alert lb-alert-info">
            ℹ️ <strong>참고</strong>: 본 계산기는 교육 및 참고 목적으로만 사용하시기 바랍니다. 실제 투자 결정 시에는 전문가와 상담하시기 바랍니다. 복리 수익과 은퇴 후 원금 보존/소진 가정을 비교한 시뮬레이션 결과입니다.
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
